import { ApeironLinkButton } from '@apeiron/temp'
import { Box, styled, Typography } from '@mui/material'
import ENV_CONFIG from '@src/config'
import { FC } from 'react'
import { Trans, useTranslation } from 'react-i18next'

const Container = styled(Box)`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
`

const Message = styled(Typography)`
  font-size: 14px;
  margin-top: 8px;
`

const StyledApeironLink = styled(ApeironLinkButton)`
  color: #3682eb;
  font-weight: 400;
  line-height: 14px;
  margin-bottom: 3px;
  text-decoration: underline;
`

const RoninFreeTransactionMessage: FC<Props> = (props: Props) => {
  const { className } = props

  const { t } = useTranslation()

  return (
    <Container className={className}>
      <Message>
        <Trans
          components={{
            link1: (
              <StyledApeironLink
                target='_blank'
                url={ENV_CONFIG.EXTERNAL_URL.WALLET.RONIN.TUTORIAL.OFFICIAL}
              />
            )
          }}
        >
          {t('wallet.ronin.create_one')}
        </Trans>
      </Message>
    </Container>
  )
}

type Props = {
  className?: string
}

export default RoninFreeTransactionMessage
